import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';
import profileImg from '../assets/img/profile.JPG';

const Hero = () => {
  const typedRef = useRef(null);

  useEffect(() => {
    const options = {
      strings: ['SOFTWARE ENGINEER', 'FLUTTER DEVELOPER', 'C PROGRAMMER'],
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 2000,
      loop: true
    };

    const typed = new Typed(typedRef.current, options);

    return () => {
      typed.destroy();
    };
  }, []);

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(27, 47, 69, 0.75), rgba(27, 47, 69, 0.75)), url(${profileImg})`,
    backgroundPosition: 'top center',
    backgroundSize: 'cover',
  };

  return (
    <section id="hero" className="hero section d-flex align-items-center" style={heroStyle}>
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <h2 className="hero-name">MUHAMMAD JAHANZAIB IQBAL</h2>
        <p className="hero-tagline">
          I'm <span ref={typedRef} className="typed-text"></span>
        </p>
      </div>
    </section>
  );
};

export default Hero;
